import { createContext } from "react";

export type InvoiceSequenceContextType = {
  methods: {
    sync: () => Promise<void>;
    getAndIncrementInvoiceSequence: (terminalId: string) => Promise<number>;
  };
};

export const InvoiceSequenceContext = createContext<
  InvoiceSequenceContextType | undefined
>(undefined);
